import { spaceCadet } from '@cogneed/react-utils';
import { styled, ListItem, alpha } from '@mui/material';

const StyledListItem = styled(ListItem)({
  '& .MuiListItemButton-root': {
    borderRadius: 4,
    padding: 4,
  },
  '& .MuiListItemText-root': {
    margin: 0,
    '& .detectionGroupTitle': {
      display: 'flex',
      justifyContent: 'space-between',
    },
    '& .MuiTypography-h4': {
      fontSize: '0.85em',
      fontWeight: 600,
      lineHeight: 5 / 3,
      color: spaceCadet[500],
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    '& .MuiBadge-root': {
      maxWidth: 'calc(100% - 24px)',
      display: 'flex',
      flexDirection: 'row-reverse',
      alignItems: 'center',
      '& .MuiBadge-badge': {
        marginTop: 5,
        position: 'relative',
        '&.MuiBadge-colorSecondary': {
          backgroundColor: alpha(spaceCadet[400], 0.5),
        },
      },
    },
  },
});

export default StyledListItem;
